export const PAGES = {
  LANDING: "LANDING",
  FORM: "FORM",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  CANCEL: "CANCEL",
  CANCEL_SUCCESS: "CANCEL_SUCCESS",
};

export const PAYMENT_TYPES = {
  FIXED: "FIXED",
  MINIMUM_MONTHLY: "MINIMUM_MONTHLY",
  FULL_CLOSING: "FULL_CLOSING",
  PAYMENT_PLAN: "PAYMENT_PLAN",
  PRFI: "PRFI",
};

export const ACCOUNT_SELECTED = "ACCOUNT_SELECTED";
export const FORM_SUBMITTED = "FORM_SUBMITTED";
export const CANCEL_CLICKED = "CANCEL_CLICKED";
export const SET_DIRECT_DEBIT_SUCCEEDED = "SET_DIRECT_DEBIT_SUCCEEDED";
export const SET_DIRECT_DEBIT_FAILED = "SET_DIRECT_DEBIT_FAILED";
export const BACK_CLICKED = "BACK_CLICKED";
export const BACK_CLICKED_WITH_FORM_VALUES = "BACK_CLICKED_WITH_FORM_VALUES";
export const CANCEL_DIRECT_DEBIT_SUCCEEDED = "CANCEL_DIRECT_DEBIT_SUCCEEDED";
export const CANCEL_DIRECT_DEBIT_FAILED = "CANCEL_DIRECT_DEBIT_FAILED";
